import React, { useEffect} from 'react'
import VendorConversationsDetails from './../components/VendorConversationsDetails';

const VendorConversations = () => {

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])

  	return (
		<div>
			<VendorConversationsDetails />
		</div>
  	);
}

export default VendorConversations;




